import {
  Account,
  AccountStatus,
  AccountType,
  ApprovalState,
  ApprovalStatus,
  BankAccountType,
  BankAccountV2,
  ContactType,
  Document,
  DocumentStatus,
  DocumentType,
  FundingSourceStatus,
  LinkedPaymentMethod,
  PaymentMethodCode,
  PaymentMethodLinkStatus,
  RegistryCode,
  RegistryLinkStatus,
} from "@/app/types/generated/graphql";

export const demoAccount: Account = {
  identityProviderRef: "a0883295-778f-4ac8-937a-46c8bd89678f",
  id: "586adc5d-d0ca-47a6-bad6-13d1bbe7d2ce",
  tenantId: "af43280c-ba77-4ca1-9f0d-e8ee1106852f",
  firstName: "Marie",
  lastName: "Stergiou",
  email: "tracexadministrator@powerledger.io",
  privacyPolicyAcceptedDate: "2023-12-01T06:33:36.222Z",
  termsAcceptedDate: "2023-12-01T06:33:36.222Z",
  rulesAcceptedDate: "2023-12-01T06:33:36.222Z",
  linkedRegistries: [
    {
      id: "13ee44fa-e57b-4a0d-b493-0ea8ddebb221",
      registryId: "37e874c2-d028-47fe-8e59-3f90d4503ca5",
      status: RegistryLinkStatus.Registered,
      accountType: AccountType.Registry,
      registryCode: RegistryCode.Mrets,
      registryOrgLinkId: "MM773",
      __typename: "LinkedRegistry",
    },
    {
      id: "f183e594-24a3-4f5e-b2ec-18ecb674368e",
      registryId: "ed9ebda5-cf5a-4f80-a2b1-be3667d5b6b7",
      status: RegistryLinkStatus.Registered,
      accountType: AccountType.Registry,
      registryCode: RegistryCode.Ercot,
      registryOrgLinkId: "Power Ledger Inc",
      __typename: "LinkedRegistry",
    },
  ],
  status: AccountStatus.Active,
  enrolledFactors: [],
  startDateTime: "2022-08-24T08:06:08.946584Z",
  company: {
    id: "bcfac496-9602-47b6-8271-f2a935c4263c",
    businessName: "Power Ledger Inc.",
    businessType: "llc",
    industryClassification: {
      id: "8ed3f67c-7d6f-11e3-bb5b-5404a6144203",
      name: "Developer",
      businessClassificationName: "Renewable Energy",
      __typename: "IndustryClassification",
    },
    employerIdentificationNumber: "37-1981127",
    physicalAddress: {
      id: "9d945bd0-7b5e-4611-8d63-deecf8b38f03",
      line1: "95 Third Street",
      line2: "2nd Floor",
      city: "San Francisco",
      state: "CA",
      postalCode: "94103",
      countryCode: "US",
      __typename: "Address",
    },
    approvalState: {
      id: "16f8760a-264c-4ebb-93d1-32cd151b3448",
      status: ApprovalStatus.Approved,
      errorCode: null,
      errorMessage: null,
      __typename: "ApprovalState",
    },
    documents: [
      {
        id: "8145ac4a-c7a2-484e-96b0-e3c5d1956d2c",
        fileName: "EIN 2023-12-01 145123.png",
        type: DocumentType.Other,
        mediaType: "image/png",
        size: 105463,
        status: DocumentStatus.Uploaded,
        errorMessage: null,
        signedUrl:
          "https://storage.googleapis.com/tracex-encrypted-kyc-documents-au-production/586adc5d-d0ca-47a6-bad6-13d1bbe7d2ce/2023-12-01/e506fa57-f889-44de-be54-9780e6d8ec65?X-Goog-Algorithm=GOOG4-RSA-SHA256&X-Goog-Credential=tracex-prod-kyc-upload-user%40tracex-production.iam.gserviceaccount.com%2F20251119%2Fauto%2Fstorage%2Fgoog4_request&X-Goog-Date=20251119T085813Z&X-Goog-Expires=600&X-Goog-SignedHeaders=host&X-Goog-Signature=945414ee43126ded20131371fa60a5bbdbe2f00f5f71299e627fb15bd045cf95d2073afb9a40136688f95d4619c59e07480f0fd280729cb2ba735d5873e8a1592721430b7d67ce8ac94336e949d11da9729fca3ebf24d628cf19cae8c00e77696da58c427ca2ca17815d978370731fcba8bed7bd22576c1faa0cdf53fcb92f1e175ab71ac625c3b122853c65ba8753b5705d074bcec4dbe9818d43db7e569e2f1589e8f0448f478633089851c44a2d632c44fe961266b71de98298b2c60364fb51a3d0b4cffd956a980296d49c9171f2aa78daee7bd323ea8a809dd31c6c42d1e295e2f205aa7015bc9b9114bafc3a4f37e45bb8c6623a771dda6e17d2ffdb93",
        approvalState: {
          id: "75c21616-9d83-49dc-a2ae-087784d1bf34",
          status: ApprovalStatus.Approved,
          errorCode: null,
          errorMessage: null,
          __typename: "ApprovalState",
        },
        __typename: "Document",
      },
    ],
    contacts: [
      {
        id: "fe5ff163-1703-42d1-b6be-330eb7db5082",
        firstName: "Jemma",
        lastName: "Green",
        jobTitle: "Director",
        dateOfBirth: "1979-04-07",
        identityNumber: null,
        physicalAddress: {
          id: "30e705ef-95bc-460f-974b-e87d77103208",
          line1: "Rägetenstrasse 15",
          line2: null,
          city: "Walchwil",
          state: "ZG",
          postalCode: "6318",
          countryCode: "CH",
          __typename: "Address",
        },
        passportNumber: "PA4935979",
        passportCountryCode: "AU",
        type: ContactType.BeneficialOwner,
        approvalState: {
          id: "a30e837f-fdb6-4cdd-9ec2-129961f8d747",
          status: ApprovalStatus.Approved,
          errorCode: null,
          errorMessage: null,
          __typename: "ApprovalState",
        },
        documents: [
          {
            id: "5c9b418d-a699-4621-b6cd-73b0d5f1d9ee",
            fileName: "Jemma PP 2023-12-01 145000.png",
            type: DocumentType.Passport,
            mediaType: "image/png",
            size: 609840,
            status: DocumentStatus.Uploaded,
            errorMessage: null,
            signedUrl:
              "https://storage.googleapis.com/tracex-encrypted-kyc-documents-au-production/586adc5d-d0ca-47a6-bad6-13d1bbe7d2ce/2023-12-01/264533dc-622d-41e1-8a28-f501448246a0?X-Goog-Algorithm=GOOG4-RSA-SHA256&X-Goog-Credential=tracex-prod-kyc-upload-user%40tracex-production.iam.gserviceaccount.com%2F20251119%2Fauto%2Fstorage%2Fgoog4_request&X-Goog-Date=20251119T085813Z&X-Goog-Expires=600&X-Goog-SignedHeaders=host&X-Goog-Signature=7c02915f7dfb5a08d40329420d73d38f03380d34682259f12a02c0be8f58371092ff0c155b8513dc46a12610a9325634ff0353aa9ec340392b838c89325190e0e18f3398e94a1ff805c0917d626517533735625dc09d705ecef3f1f52742f5ab9e38d8d18923a7f50e33dd4d7dc735e73ff96396ffb720e74d76df6638ccfd3f471bc58fd23cca24bad1be549d12cb48fcf21def076b210ce01114b689873b1b0d263612dc64e49a59ac40ca6c9570f9ef2ef59ebf096d4c84120ab6679816a74be8f87f3ede40ffaa1dd9897b818afcf7b6f37c71266f625f6ecd8478dd33e3aac87791db69fbbaf8cb136161e70b2752ad9a2ac9944f51f1e47fda38c1f815",
            approvalState: {
              id: "b9411c96-1489-4cb6-a3ce-72ef67305476",
              status: ApprovalStatus.Approved,
              errorCode: null,
              errorMessage: null,
              __typename: "ApprovalState",
            },
            __typename: "Document",
          },
        ],
        __typename: "CompanyContact",
      },
      {
        id: "7821eeb4-7191-42d8-963d-ac684fd96366",
        firstName: "Jemma",
        lastName: "Green",
        jobTitle: "Director",
        dateOfBirth: "1979-04-07",
        identityNumber: null,
        physicalAddress: {
          id: "015c9f79-f5d0-4866-9c3a-edf34ea5df48",
          line1: "Rägetenstrasse 15",
          line2: null,
          city: "Walchwil",
          state: "ZG",
          postalCode: "6318",
          countryCode: "CH",
          __typename: "Address",
        },
        passportNumber: "PA4935979",
        passportCountryCode: "AU",
        type: ContactType.Controller,
        __typename: "CompanyContact",
        approvalState: {
          id: "68fa008a-db39-4001-83ea-871b85e4ec0d",
          status: ApprovalStatus.Approved,
          errorCode: null,
          errorMessage: null,
          __typename: "ApprovalState",
        },
        documents: [
          {
            id: "51483bd9-803f-4f58-ad33-c0e9c5768e95",
            fileName: "Jemma PP 2023-12-01 145000.png",
            type: DocumentType.Passport,
            mediaType: "image/png",
            size: 609840,
            status: DocumentStatus.Uploaded,
            errorMessage: null,
            signedUrl:
              "https://storage.googleapis.com/tracex-encrypted-kyc-documents-au-production/586adc5d-d0ca-47a6-bad6-13d1bbe7d2ce/2023-12-01/fc134e80-120c-48c8-909b-6dc23813aaee?X-Goog-Algorithm=GOOG4-RSA-SHA256&X-Goog-Credential=tracex-prod-kyc-upload-user%40tracex-production.iam.gserviceaccount.com%2F20251119%2Fauto%2Fstorage%2Fgoog4_request&X-Goog-Date=20251119T085813Z&X-Goog-Expires=600&X-Goog-SignedHeaders=host&X-Goog-Signature=0451d35337c4058867927183bf38f8e2aa4a6e7c3f2500e6d0ac1437088ba6aa2629981389a1f715c656fea87db156a70670431ee2e60fb6af55a3d32496beb062a0fea3d410f56d52737ea05a07d5a92ec76525a2948f19533edd7b36e9b08c8cc3415dee9cc7c1968a470cf1929da1916b68afb0f8a0619c620add4aa3a9e44e8b3fd23c6f22a984af53a1aeab4c231a631c12d50d849fc6a1c684e01f42eca9fff595f75faad17df51d461b799bfff14f9b5bc5ba7d4b421adad63bc3b28637ae6e46c916d3898cb1728970c5d2c2ba3f2a0229e011c85e1cd1b7922bd4c672ade0e95112aac730c4dca0ef92f5ca3a0d0a1d80cd909d5bb61b48d3f6be84",
            approvalState: {
              id: "88f4d763-171d-4650-afef-53aaf3ee9466",
              status: ApprovalStatus.Rejected,
              errorCode: "ACC-0039",
              errorMessage: "ID is expired or missing expiration date, Scan DOB does not match DOB on account",
              __typename: "ApprovalState",
            },
            __typename: "Document",
          },
        ],
      },
      {
        id: "ce042a54-f228-4144-b549-03d9b0d1d761",
        firstName: "John",
        lastName: "Bulich",
        jobTitle: "Director",
        dateOfBirth: "1963-10-23",
        identityNumber: null,
        physicalAddress: {
          id: "0ab21489-b98f-446f-98a0-fcad12e574e8",
          line1: "41 Fortview Rd",
          line2: null,
          city: "Mount Claremont",
          state: "WA",
          postalCode: "6010",
          countryCode: "AU",
          __typename: "Address",
        },
        passportNumber: "PA6943019",
        passportCountryCode: "AU",
        type: ContactType.BeneficialOwner,
        approvalState: {
          id: "d36cae72-e3c2-4fcf-b985-af3a7f78f0ee",
          status: ApprovalStatus.Approved,
          errorCode: null,
          errorMessage: null,
          __typename: "ApprovalState",
        },
        documents: [
          {
            id: "f34f092a-04be-4edd-8a55-33e37fe8d059",
            fileName: "John Bulich passport.jpg",
            type: DocumentType.Passport,
            mediaType: "image/jpeg",
            size: 362499,
            status: DocumentStatus.Uploaded,
            errorMessage: null,
            signedUrl:
              "https://storage.googleapis.com/tracex-encrypted-kyc-documents-au-production/586adc5d-d0ca-47a6-bad6-13d1bbe7d2ce/2023-12-11/80de119d-d8ae-48a1-a718-fb740862c172?X-Goog-Algorithm=GOOG4-RSA-SHA256&X-Goog-Credential=tracex-prod-kyc-upload-user%40tracex-production.iam.gserviceaccount.com%2F20251119%2Fauto%2Fstorage%2Fgoog4_request&X-Goog-Date=20251119T085813Z&X-Goog-Expires=600&X-Goog-SignedHeaders=host&X-Goog-Signature=bf7d425bcc0796857e22b728a51a79e3e7984551d01a187988a23d97d41742b35f132752822e225d390f8d853fa650f0dcced1b48c2105335239f3efd09d46176375f359e3e4e95a1bfb7ad4bec8e239a46485a4c68c9e55f70d7eab413d7db835b5604f5a6833b3e1f427a5e768d42515dbc892caedd27bcc3a7de18899e8bdfb187110b78c559cb00d2d55a54450655495741a6ab1d0385d560e46e97641d12204b4056ab37bf7d7bb2134b0598d1222b6d551cb64c10c222c81d5fd5c7c894a1205de40098a397cf1d93dcc2e55b84fb80e9ef32fa83f7e44c05e5fd34c960c3cc6883d4b02d8b22797f53b16e15ccccfd20483174e47b091d7ed944cf186",
            approvalState: {
              id: "864191dc-30b0-45f4-9788-056abaeddc8a",
              status: ApprovalStatus.Approved,
              errorCode: null,
              errorMessage: null,
              __typename: "ApprovalState",
            },
            __typename: "Document",
          },
        ],
        __typename: "CompanyContact",
      },
    ],
    __typename: "Company",
  },
  linkedPaymentMethods: [
    {
      id: "19214c77-aeaa-4c36-b346-e0442f6649b1",
      initialisingToken: "test-init-token",
      status: PaymentMethodLinkStatus.Active,
      statusMessage: null,
      paymentMethod: {
        id: "d9a156bf-1d05-4bae-899f-103bc7b77c49",
        code: PaymentMethodCode.DwollaPlaid,
        displayName: "Plaid",
        description:
          "Using the Dwolla Plaid Link, verify your accounts in seconds by simply inputting your banking credentials via Plaid",
        paymentProvider: {
          __typename: "PaymentProviderV2",
          id: "ca5b7829-6c9c-45ee-8662-57843a62aa9c",
          name: "DWOLLA",
          displayName: "Dwolla",
          description: "Link your bank account via Dwolla to send and receive money within the TraceX platform",
          paymentMethods: [],
        },
        __typename: "PaymentMethod",
      },
      fundingSource: {
        __typename: "BankAccountV2",
        id: "a85d229a-0d80-4046-8d16-1823f6616ca6",
        currencyCode: null,
        status: FundingSourceStatus.Verified,
        statusMessage: null,
        errorCode: null,
        accountName: "Example",
        accountNumberMasked: "1234",
        accountType: BankAccountType.Savings,
      } as BankAccountV2,
      __typename: "LinkedPaymentMethod",
    } as LinkedPaymentMethod,
  ],
  __typename: "Account",
};

export const demoAccountWithUploadedDocuments = {
  ...demoAccount,
  company: {
    ...demoAccount.company,
    documents: [
      {
        id: "1321-5125412-151",
        fileName: "test-document-upload-success.png",
        type: "ID_CARD",
        mediaType: "image/png",
        size: 3453,
        status: DocumentStatus.Uploaded,
        errorMessage: null,
        approvalState: {
          id: "5c7b9c38-ef3c-4301-b3dc-7f38a4cd07c6",
          status: ApprovalStatus.Approved,
          errorMessage: "Error 50",
          errorCode: null,
          __typename: "ApprovalState",
        } as ApprovalState,
        __typename: "Document",
      } as Document,
    ],
  },
};

export const demoAccountWithFewDetails = {
  id: "586adc5d-d0ca-47a6-bad6-13d1bbe7d2ce",
  termsAcceptedDate: "2023-12-01T06:33:36.222Z",
  rulesAcceptedDate: "2023-12-01T06:33:36.222Z",
  privacyPolicyAcceptedDate: "2023-12-01T06:33:36.222Z",
  status: "ACTIVE",
  tenantId: "af43280c-ba77-4ca1-9f0d-e8ee1106852f",
  firstName: "Marie",
  lastName: "Stergiou",
  email: "tracexadministrator@powerledger.io",
  linkedRegistries: [
    {
      id: "13ee44fa-e57b-4a0d-b493-0ea8ddebb221",
      registryId: "37e874c2-d028-47fe-8e59-3f90d4503ca5",
      status: "REGISTERED",
      accountType: "REGISTRY",
      registryCode: "MRETS",
      registryOrgLinkId: "MM773",
      __typename: "LinkedRegistry",
    },
    {
      id: "f183e594-24a3-4f5e-b2ec-18ecb674368e",
      registryId: "ed9ebda5-cf5a-4f80-a2b1-be3667d5b6b7",
      status: "REGISTERED",
      accountType: "REGISTRY",
      registryCode: "ERCOT",
      registryOrgLinkId: "Power Ledger Inc",
      __typename: "LinkedRegistry",
    },
  ],
  __typename: "Account",
};

export const demoAccountData = {
  id: demoAccount.id,
  tenantId: demoAccount.tenantId,
  type: demoAccount.linkedRegistries[0].accountType,
  status: demoAccount.status,
  registryCode: demoAccount.linkedRegistries[0].registryCode as RegistryCode,
};

export const initialRequiredDocument: Document[] = [
  {
    __typename: "Document",
    id: "70a16423-8c08-43ee-812a-5ddb956761bb",
    fileName: null,
    type: DocumentType.IdCard,
    mediaType: null,
    size: null,
    status: DocumentStatus.PendingUpload,
    errorMessage: null,
    signedUrl: null,
    approvalState: null,
  },
  {
    id: "535fbbc6-b04a-4be6-aef1-eb71e4aa8b4e",
    fileName: null,
    type: DocumentType.Other,
    mediaType: null,
    size: null,
    status: DocumentStatus.PendingUpload,
    errorMessage: null,
    signedUrl: null,
    approvalState: null,
    __typename: "Document",
  },
];
